function randInt(min, max){ return Math.floor(Math.random()*(max-min+1))+min; }

export async function getDashboardStats(range = 30){
  // Здесь — HTTP-запрос к вашему бэку. Возвращаем формат:
  // { totalLeads, leadsToday, visitsToday, conversionRate, avgTimeToContact, leadsDelta, avgLeadsPerDay, lastUpdated, series: [{label, value}], sources: [{name,count,color}] }
  const days = Number(range) || 30;
  const series = [];
  for(let i=0;i<days;i++){
    series.push({ label: `${i+1}`, value: randInt(10,80) });
  }
  const total = series.reduce((s,x)=>s+x.value,0);
  return new Promise(resolve => setTimeout(()=> resolve({
    totalLeads: total,
    leadsToday: randInt(5,50),
    visitsToday: randInt(200,1000),
    conversionRate: +( (randInt(2,6)/100).toFixed(3) ),
    avgTimeToContact: randInt(10,120),
    leadsDelta: +( (randInt(-20,30)).toFixed(1) ),
    avgLeadsPerDay: Math.round(total/days),
    lastUpdated: new Date().toISOString(),
    series,
    sources: [
      { name: 'Контекст', count: Math.round(total*0.4), color: '#4f46e5' },
      { name: 'Соцсети', count: Math.round(total*0.25), color: '#06b6d4' },
      { name: 'Органика', count: Math.round(total*0.2), color: '#fb7185' },
      { name: 'Реферальные', count: Math.round(total*0.15), color: '#f59e0b' }
    ]
  }), 300));
}

export async function getRecentLeads(range = 30, page = 1){
  // Вернём массив заявок
  const names = ['Анна','Иван','Мария','Алексей','Ольга','Дмитрий'];
  const sources = ['Контекст','Соцсети','Органика','Реферальные'];
  const arr = [];
  for(let i=0;i<12;i++){
    arr.push({ id: `${Date.now()}${i}`, time: new Date(Date.now()-randInt(0,60*60*24*1000)).toISOString(), name: names[randInt(0,names.length-1)], contact: randInt(7000000000,7999999999).toString(), source: sources[randInt(0,sources.length-1)], note: Math.random()>0.6?'Позвонить утром':'' });
  }
  return new Promise(resolve => setTimeout(()=>resolve(arr), 200));
}